/** Zeiträume für den Report (FR-21): Jahr (im laufenden Jahr bis heute), Quartal oder Monat. */
export type PeriodKey = 'jahr' | 'alle' | 'q1' | 'q2' | 'q3' | 'q4' | `m${number}`;

/** Gebucht wird in SevDesk seit 2018 (F-4); "Alle Jahre" beginnt dort. */
export const FIRST_YEAR = 2018;

export const PERIOD_OPTIONS: { key: PeriodKey; label: string }[] = [
  { key: 'jahr', label: 'Ganzes Jahr' },
  // z.B. eine Veranstaltung über den Jahreswechsel, mit Tag-Filter
  { key: 'alle', label: 'Alle Jahre' },
  { key: 'q1', label: '1. Quartal' },
  { key: 'q2', label: '2. Quartal' },
  { key: 'q3', label: '3. Quartal' },
  { key: 'q4', label: '4. Quartal' },
  ...[
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ].map((label, i) => ({ key: `m${i + 1}` as PeriodKey, label })),
];

const pad = (n: number) => String(n).padStart(2, '0');
const lastDay = (year: number, month: number) => new Date(Date.UTC(year, month, 0)).getUTCDate();

/** Von/bis als ISO-Datum. Im laufenden Jahr endet der Zeitraum spätestens heute. */
export function periodRange(
  year: number,
  key: PeriodKey,
  today: string,
): { from: string; to: string } {
  if (key === 'alle') return { from: `${FIRST_YEAR}-01-01`, to: today };
  let fromMonth = 1;
  let toMonth = 12;
  if (key.startsWith('q')) {
    const q = Number(key.slice(1));
    fromMonth = (q - 1) * 3 + 1;
    toMonth = fromMonth + 2;
  } else if (key.startsWith('m')) {
    fromMonth = toMonth = Number(key.slice(1));
  }
  const from = `${year}-${pad(fromMonth)}-01`;
  const end = `${year}-${pad(toMonth)}-${pad(lastDay(year, toMonth))}`;
  return { from, to: end > today && from <= today ? today : end };
}

const MONTHS = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

/** "2026-03" -> "Mär 26"; ein ganzes Jahr ("2026") bleibt, wie es ist. */
export function monthLabel(month: string): string {
  if (month.length === 4) return month;
  return `${MONTHS[Number(month.slice(5, 7)) - 1]} ${month.slice(2, 4)}`;
}
